export default __webpack_public_path__ + "images/assets/30e60cbb644dedf844a5c96517f467ed.svg";